import { getModalStore } from './_getModalStore'

const useQuickOfferModalStore = getModalStore('quick-offer-modal')

export default useQuickOfferModalStore
